import * as moment from "moment";
import { showWarningToast } from "../validation/ToastContainer";

export const AuditScope = {
    /**
     * Date range = Month. 1 tick = 1 day
     */
    BY_MONTH: 'Month',

    /**
     * Date range = Year. 1 tick = 1 month
     */
    BY_YEAR: 'Year',


    /**
     * Date range = Day. 1 tick = 1 hour
     */
    BY_DAY: 'Day',

    /**
     * Date range = Week. 1 tick = 1 day
     */
    BY_WEEK: 'Week',

    /**
     * Date range = Day. 1 tick = 1 hour
     */
    BY_HOUR: 'Hour',

    /**
     * Date range = Hour. 1 tick = 1 minute
     */
    LAST_HOUR: 'Last hour',

    /**
     * Date range = Day. 1 tick = 1 hour
     */
    LAST_DAY: 'Last day',

    /**
     * Date range = Month. 1 tick = 1 day
     */
    LAST_MONTH: 'Last month',

    /**
     * Date range = 3 Month. 1 tick = 1 month
     */
    THREE_MONTH: 'Three month',

    /**
     * Date range = Custom. 1 tick = 1 day
     */
    CUSTOM: 'Custom'
}


export const ChartDynamicLabels = {

    [AuditScope.BY_MONTH]: () => {
        //const days = [];
        // let start = moment().subtract(1, 'month');
        // let start = moment().subtract(30, 'days');
        // const end = moment();
        // //start = moment(start).add(1, 'day');
        // while (start <= end) {
        //     days.push(start.format('MM-DD'));
        //     start = moment(start).add(1, 'day');
        // }

        const result = [];
        const start = moment().subtract(29, 'days');
        for (let i = 0; i <= 29; i++) {
            result.push(start.format('MM-DD'));
            start.add(1, 'day');
        }

        return result;
    },
    [AuditScope.BY_YEAR]: () => {
        const result = [];
        let start = moment().subtract(1, 'year').startOf('month');
        for (let i = 0; i <= 12; i++) {
            result.push(start.format("MMM"))
            start = start.add(1, 'month').startOf('month');
        }
        return result;
    },
    [AuditScope.BY_HOUR]: () => {
        const result = [];
        const start = moment().subtract(24, 'hour')
        for (let i = 0; i <= 24; i++) {
            result.push(start.format('HH:00'));
            start.add(1, 'hour');
        }
        return result;
    },
    [AuditScope.BY_DAY]: () => {
        const result = [];
        // //UTC datetime
        // const utcDatetime = moment.utc();
        // //local datetime
        // const localDatetime = moment();
        // //Different number of hours
        // //const hrsDiff = localDatetime.diff(utcDatetime, 'hours');
        // const hrsDiff = localDatetime.utcOffset() / 60;

        const start = moment().subtract(23, 'hour')
        // start.add(hrsDiff, 'hour');
        // start.add(1, 'hour');
        for (let i = 0; i < 24; i++) {
            result.push(start.format('HH:00'));
            start.add(1, 'hour');
        }
        return result;
    },
    [AuditScope.LAST_DAY]: () => {
        const result = [];
        const start = moment().subtract(24, 'hour')

        for (let i = 0; i <= 24; i++) {
            result.push(start.format('HH:00'));
            start.add(1, 'hour');
        }
        return result;
    },
    [AuditScope.BY_WEEK]: () => {
        const result = [];
        // const start = moment().subtract(7, 'days');
        // for (let i = 0; i <= 7; i++) {
        //     result.push(start.format('ddd'));
        //     start.add(1, 'day');
        // }
        const start = moment().subtract(6, 'days');
        for (let i = 0; i <= 6; i++) {
            result.push(start.format('ddd'));
            start.add(1, 'day');
        }
        return result;
    },
    [AuditScope.LAST_HOUR]: () => {
        let prev = moment().subtract(1, 'hour');
        const result = [];
        for (let i = 0; i < 60; i++) {
            result.push(prev.format('HH:mm'));
            prev = moment(prev).add(1, 'minute');
        }
        return result;
    },
    [AuditScope.LAST_MONTH]: () => {
        const days = [];

        let start = moment().subtract(30, 'days');
        const end = moment();

        while (start <= end) {
            days.push(start.format('YYYY-MM-DD'));
            start = moment(start).add(1, 'day');
        }

        return days;
    },
    [AuditScope.THREE_MONTH]: () => {
        const result = [];
        const month = moment().subtract(2, 'month').endOf('month');
        result.push(month.format('MMM'));
        month.startOf('month').add(1, 'month').endOf('month');
        result.push(month.format('MMM'));
        month.startOf('month').add(1, 'month').endOf('month');
        result.push(month.format('MMM'));
        return result;
    }
}

export const ChartDynamicLabelsCustom = {

    [AuditScope.CUSTOM]: (fromDate,toDate) => {
        // 1. Parse the input date strings into moment objects
        // Moment.js can usually parse these standard date strings directly.
        const start = moment(fromDate);
        const end = moment(toDate);

        // 2. Initialize an empty array to store the labels
        const result = [];

        // 3. Basic validation (optional but recommended)
        if (!start.isValid() || !end.isValid()) {
            showWarningToast("Invalid date format provided!", "Custom Dates")
            return []; // Return empty if dates are invalid
        }

        // Ensure start date is not after end date
        if (start.isAfter(end)) {
            console.warn("fromDate cannot be after toDate. Returning empty array.");
            showWarningToast("From Date cannot be after To Date!", "Custom Dates")
            return [];
        }

        // 4. Clone the start date to use as an iterator without modifying the original 'start'
        let current = start.clone();

        // 5. Loop from the start date up to and including the end date
        //    'day' ensures we compare based on the date part, ignoring time differences
        //    if you were only comparing date objects without time. In this case,
        //    since we increment by full days, it works fine.
        while (current.isSameOrBefore(end, 'day')) {
            result.push(current.format('MM-DD'));
            current.add(1, 'day');
        }

        return result;
 
    },
}

